<template>
  <el-dialog title="图斑信息" :visible.sync="visibleSync" width="800px">
    <div v-if="spotInfo">
      <el-form label-width="100px">
        <el-form-item label="野外编号"><span>{{ spotInfo.fieldNo }}</span></el-form-item>
        <el-form-item label="名称"><span>{{ spotInfo.name }}</span></el-form-item>
        <el-form-item label="省"><span>{{ spotInfo.provinceName || '-' }}</span></el-form-item>
        <el-form-item label="市"><span>{{ spotInfo.cityName || '-' }}</span></el-form-item>
        <el-form-item label="区县"><span>{{ spotInfo.districtName || '-' }}</span></el-form-item>
        <el-form-item label="乡镇/街道"><span>{{ spotInfo.township || '-' }}</span></el-form-item>
        <el-form-item label="面积(㎡)"><span>{{ spotInfo.area }}</span></el-form-item>
        <el-form-item label="描述"><span>{{ spotInfo.description || '-' }}</span></el-form-item>
      </el-form>
    </div>

    <el-tabs v-model="activeTab" type="card" style="margin-top: 16px;">
      <el-tab-pane v-for="stage in stageList" :key="stage.id" :label="stage.label" :name="String(stage.id)">
        <div v-if="stageDetail[stage.id]">
          <el-form label-width="120px" size="small">
            <el-form-item label="植被覆盖率"><span>{{ stageDetail[stage.id].vegetationCoverage || '-' }}%</span></el-form-item>
            <el-form-item label="植被成活率"><span>{{ stageDetail[stage.id].vegetationSurvivalRate || '-' }}%</span></el-form-item>
            <el-form-item label="土壤质量达标率"><span>{{ stageDetail[stage.id].soilQualityRate || '-' }}%</span></el-form-item>
            <el-form-item label="水量质量达标率"><span>{{ stageDetail[stage.id].waterQualityRate || '-' }}%</span></el-form-item>
            <el-form-item label="修复面积"><span>{{ stageDetail[stage.id].repairArea || '-' }}㎡</span></el-form-item>
            <el-form-item label="状态"><span>{{ stageDetail[stage.id].status === 1 ? '已完结' : '未完结' }}</span></el-form-item>
            <el-form-item label="创建时间"><span>{{ stageDetail[stage.id].createTime }}</span></el-form-item>
            <el-form-item label="完结时间" v-if="stageDetail[stage.id].finishTime"><span>{{ stageDetail[stage.id].finishTime }}</span></el-form-item>
          </el-form>

          <!-- 资源文件 -->
          <div v-if="stageDetail[stage.id].resources && stageDetail[stage.id].resources.length > 0">
            <div class="resource-title">资源文件</div>
            <div class="resource-list">
              <div v-for="(item, idx) in stageDetail[stage.id].resources" :key="idx" class="resource-item">
                <el-tag size="small" :type="item.type === 'photo' ? 'success' : item.type === 'table' ? 'primary' : 'warning'">
                  {{ item.type === 'photo' ? '拍照' : item.type === 'table' ? '表格' : '报告' }}
                </el-tag>
                <span style="margin-left: 8px;">{{ item.name || item.url }}</span>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    spotId: Number,
    stageList: Array
  },
  data() {
    return {
      spotInfo: {},
      activeTab: "",
      stageDetail: {}
    };
  },
  computed: {
    visibleSync: {
      get() { return this.visible; },
      set(val) { this.$emit("update:visible", val); }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.loadSpotInfo();
        this.loadStageDetails();
      }
    },
    stageList: {
      handler(val) {
        if (val && val.length > 0) {
          this.activeTab = String(val[0].id);
        }
      },
      immediate: true
    }
  },
  methods: {
    loadSpotInfo() {
      this.$apis.get("/admin/spot/page", { pageIndex: 1, pageSize: 1000 }).then(res => {
        if (res.data.code == 200 && res.data.data && res.data.data.list) {
          const spot = res.data.data.list.find(item => item.id === this.spotId);
          if (spot) this.spotInfo = spot;
        }
      });
    },
    loadStageDetails() {
      if (!this.stageList) return;
      this.stageList.forEach(stage => {
        this.$apis.get("/admin/spot/stage/detail", { stageId: stage.id }).then(res => {
          if (res.data.code == 200 && res.data.data) {
            this.$set(this.stageDetail, stage.id, res.data.data);
          }
        });
      });
    }
  }
};
</script>

<style scoped>
.resource-title {
  font-weight: bold;
  color: #333;
  margin: 12px 0 8px;
}
.resource-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.resource-item {
  padding: 6px 10px;
  background: #f5f7fa;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/page/components/spotStageInfo.vue